import { createStyles, Divider, Theme, WithStyles, withStyles } from '@material-ui/core'
import moment from 'moment'
import * as R from 'ramda'
import React from 'react'

import {
	CompletionStatus,
	IncentiveEarnedItems,
	ParticipantOutcome,
	StipendFrequencyItems,
	SupportiveService,
	WageFrequencyItems
} from '../../../services/Model/Outcome'
import { StateIDs } from '../../../services/Model/Participant'
import { mapToYesOrNoWithNullable, mapYesNoUnknownToBool } from '../../../services/utils'
// tslint:disable-next-line:max-line-length
import ActivityInformationSection from '../../FormTemplates/OutcomesActivityInformationSection/OutcomesActivityInformationSection'
import OutcomesFormActions from '../../FormTemplates/OutcomesFormActions/OutcomesFormActions'
import AcademicAwardDetails from '../FormItems/AcademicAwardDetails'
import IncentiveEarned from '../FormItems/IncentiveEarnedSection'
import JobPlacementSection from '../FormItems/JobPlacementSection'
import { getOutcomesAccordingToStatus, validateForm } from '../formUtils'

import OtherEnrolledAcademicDetails from '../FormItems/OtherEnrolledAcademicDetails'
import OtherEnrolledActivityInformationSection from '../FormItems/OtherEnrolledActivityInformationSection'
import OtherEnrolledCredentialsEarned from '../FormItems/OtherEnrolledCredentialsEarned'
import SupportedServicesSection from '../FormItems/SupportedServices/SupportedServicesSection'
import OutcomeDateItem from 'src/Forms/FormTemplates/CustomOutcomeDate/OutcomeDateItem'
import {updateDateCredentailAttained} from '../../../features/pacticipantOutcomeSlice'
import { connect, ConnectedProps } from 'react-redux'
import SkillGainedSection from '../FormItems/SkillGainedSection/SkillGainedSection'

const mapStateToProps = (state:any) => {
  return {
    dateCredentialAttained: state.participantOutcome.dateCredentialAttained,
    // dateSkillAttained: state.participantOutcome.dateSkillAttained
  }
};

const mapDispatchToProps = { updateDateCredentailAttained };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
)

type PropsFromRedux = ConnectedProps<typeof connector>

interface IWBLOEProps extends WithStyles<typeof styles>, PropsFromRedux {
	outcomes: ParticipantOutcome
	onSubmit: (outcomes: ParticipantOutcome) => void
  employers: any[]
  onLocalOutcomesUpdate: (outcomes: ParticipantOutcome) => void
  outcomesCopy: ParticipantOutcome
}

interface IWBLOEState {
	localOutcomes: ParticipantOutcome
}

const setInitialState = (props: IWBLOEProps) => {
  console.log(`onLocalOutcomesUpdate IntershipsWorkbasedLearningOtherEnrolled setInitialState props.outcomes=${props.outcomes?.jobPlacementEmployerAddress1}`)
	return {
		localOutcomes: props.outcomes,
	}
}

const TOP_START_DATE = new Date()

export class InternshipsWorkbasedLearningOtherEnrolled extends React.Component<IWBLOEProps, IWBLOEState> {
	public readonly state: IWBLOEState = setInitialState(this.props)
	formRef: React.RefObject<HTMLFormElement> = React.createRef()

	onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const isBulk = this.state.localOutcomes.participantEnrollmentType === 2
		const isFormValid = isBulk || validateForm(this.formRef)
		if (isFormValid) {
			this.props.onSubmit(this.state.localOutcomes)
		}
	}

	onCancel = () => {
		this.updateLocalOutcomes(this.props.outcomesCopy)
	}

	updateLocalOutcomes = (outcomes: ParticipantOutcome) => {
		this.setState({
			localOutcomes: outcomes,
		})
    this.props.onLocalOutcomesUpdate(outcomes)
	}

	handleDateChange = (prop: string, value: Date | string) => {
		const updatedOutcomes = { ...this.state.localOutcomes, [prop]: moment(value).format("YYYY-MM-DD") }

		this.setState({
			localOutcomes: updatedOutcomes,
		})
	}

	handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
		const { name, value } = e.target
    console.log(`name4=${name}, value=${value}`)
		const updatedOutcomes = { ...this.state.localOutcomes, [name]: value }
    if(name === 'jobPlacementEmployerState' && value == 'RI'){
      updatedOutcomes.jobPlacementEmployerCity = ''
      updatedOutcomes.jobPlacementEmployerZipcode = ''
    }
		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { localOutcomes } = this.state
		const frequencyItem = WageFrequencyItems.find(i => i.label === e.target.value)
		const wageFrequency = frequencyItem && frequencyItem.value ? frequencyItem.value : null
		const updatedOutcomes = {
			...localOutcomes,
			wageFrequency
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleStipendFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { localOutcomes } = this.state
		const frequencyItem = StipendFrequencyItems.find(i => i.label === e.target.value)
		const stipendFrequency = frequencyItem && frequencyItem.value ? frequencyItem.value : null
		const updatedOutcomes = {
			...localOutcomes,
			stipendFrequency
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleCompletionStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const updatedOutcomes = getOutcomesAccordingToStatus(value, localOutcomes)

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleIncentiveEarnedChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const incentiveEarnedItem = IncentiveEarnedItems.find((i) => i.label === value)
		const incentiveEarnedProp = incentiveEarnedItem && incentiveEarnedItem.value ?
			incentiveEarnedItem.value : null
		const updatedOutcomes = {
			...localOutcomes,
			incentiveEarned: incentiveEarnedProp,
			incentiveType: null,
			stipendAmount: null,
			stipendFrequency: null,
			wageAmount: null,
			wageFrequency: null
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	stipendReceivedHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const updatedOutcomes = {
			...localOutcomes,
			stipendReceived: value === '' || value === null ? null : value === 'Yes',
			stipendAmount: value === 'Yes' ? localOutcomes.stipendAmount : null,
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleEarnedAcademicDegree = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const earnedDegreeOrCredit = mapYesNoUnknownToBool(e.target.value)
		const { localOutcomes } = this.state

		this.updateLocalOutcomes({
			...localOutcomes,
			earnedDegreeOrCredit,
			creditsEarned: earnedDegreeOrCredit ? localOutcomes.creditsEarned : null,
			academicCredit: earnedDegreeOrCredit ? localOutcomes.academicCredit : null,
		})
	}

	handleBenefitsProvided = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const benefitsProvided = mapYesNoUnknownToBool(value)

		const newOutcomes = {
			...localOutcomes,
			benefitsProvided,
		}

		this.updateLocalOutcomes(newOutcomes);
	}

	handlePerDiem = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const perDiem = mapYesNoUnknownToBool(value)

		const newOutcomes = {
			...localOutcomes,
			perDiem,
			jobPlacementWeeklyHours: null,
			benefitsProvided: false,
		}

		this.updateLocalOutcomes(newOutcomes);
	}

	handlePlacedJob = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const placedJob = mapYesNoUnknownToBool(value)

		const outcomesIfPlacedJob = {
			...localOutcomes,
			placedJob,
			benefitsProvided: null,
			placedJobDate: null,
			jobPlacementEmployer: null,
			jobPlacementEmployerAddress1: null,
			jobPlacementEmployerAddress2: null,
			jobPlacementEmployerCity: null,
			jobPlacementEmployerState: null,
			jobPlacementEmployerZipcode: null,
			jobPlacementIndustry: null,
			jobPlacementOccupation: null,
			jobPlacementWage: null,
			jobPlacementWageFrequency: null,
			jobPlacementWeeklyHours: null,
			paidHours: null,
			perDiem: null,
		}

		this.updateLocalOutcomes(placedJob ? outcomesIfPlacedJob : { ...localOutcomes, placedJob })
	}

	componentDidMount(): void {
		window.scrollTo(0, 0)
	}

	handleServicesChange = (services: SupportiveService[]) => {
		const { localOutcomes } = this.state;

		this.updateLocalOutcomes({
			...localOutcomes,
			services
		})
	}

	handleSupportiveServices = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const serviceProvided = mapYesNoUnknownToBool(value)

		const resetServicesProvided = {
			...localOutcomes,
			serviceProvided,
			serviceStartDate: null,
			serviceEndDate: null,
			services: []
		}

		this.updateLocalOutcomes(serviceProvided ? { ...localOutcomes, serviceProvided } : resetServicesProvided)

	}

	componentWillReceiveProps(nextProps: IWBLOEProps) {

		if (R.equals(this.props.outcomes, nextProps.outcomes)) return

		this.setState((prevState: IWBLOEState) => ({ ...prevState, localOutcomes: nextProps.outcomes }))
	}

  getDateCredentialAttainedValue(){
    if(!this.props.dateCredentialAttained){
      return ''
      // return moment(moment(new Date("2023-04-11T00:00:00.000Z")).format("YYYY-MM-DD")).toDate()
    }
    else{
      const value =  moment(moment(this.props.dateCredentialAttained).format("YYYY-MM-DD")).toDate()
      return value
    }
  }

  /* handleDateSkillAttainedChanged = (dateSkillAttained) =>{
    const { localOutcomes } = this.state;

		this.updateLocalOutcomes({
			...localOutcomes,
			dateSkillAttained
		})
  }

  handleMeasurableSkillGainChange = (measurableSkillGain) =>{
    const { localOutcomes } = this.state;
    const newOutcome:any = {
      ...localOutcomes,
			measurableSkillGain
    }
    if(!measurableSkillGain || measurableSkillGain.toLowerCase() === 'unknown'){
      newOutcome.dateSkillAttained= null
    }
		this.updateLocalOutcomes(
			newOutcome
		)
  } */

  handleDateCredentialAttained = (dateCredentialAttained)=>{
    const { localOutcomes } = this.state
    this.updateLocalOutcomes({...localOutcomes, dateCredentialAttained})
  }

	render() {
		const { classes, dateCredentialAttained } = this.props
    
		const { localOutcomes } = this.state
		const isBulk = localOutcomes.participantEnrollmentType === 2
		const placedJob = mapToYesOrNoWithNullable(localOutcomes.placedJob)

		return (
			<div className={classes.root} data-auto="form-wrapper">
				<Divider variant="middle" style={{ margin: '15px 0' }} />
				<form onSubmit={this.onFormSubmit} ref={this.formRef}>
					<div>
						<ActivityInformationSection
							startDate={localOutcomes.startDate || undefined}
							endDate={localOutcomes.completionDate || undefined}
							minEndDate={localOutcomes.startDate ? moment(localOutcomes.startDate).format('YYYY-MM-DD') : ''}
							requiredStartDate={!isBulk}
							requiredEndDate={isBulk ? false : localOutcomes.completionStatus !== CompletionStatus.ENROLLED}
							onDateChange={this.handleDateChange}
							maxStartDate={moment(TOP_START_DATE).format('YYYY-MM-DD')}
							showEndDate={localOutcomes.completionStatus !== CompletionStatus.ENROLLED}
							completionStatus={localOutcomes.completionStatus}
							handleCompletionStatusChange={this.handleCompletionStatusChange}
							dropReason={localOutcomes.dropReason || ''}
							onDropReasonChange={this.handleTextChange}
						/>
						<IncentiveEarned
							incentiveEarned={localOutcomes.incentiveEarned}
							onIncentiveEarnedChange={this.handleIncentiveEarnedChange}
							incentiveType={localOutcomes.incentiveType}
							onIncentiveTypeChange={this.handleTextChange}
							stipendAmount={localOutcomes.stipendAmount}
							stipendFrequency={localOutcomes.stipendFrequency}
							onStipendAmountChange={this.handleTextChange}
							onStipendFrequencyChange={this.handleStipendFrequencyChange}
							wageAmount={localOutcomes.wageAmount}
							wageFrequency={localOutcomes.wageFrequency}
							onWageAmountChange={this.handleTextChange}
							onWageFrequencyChange={this.handleFrequencyChange}
						/>
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<div>
						<OtherEnrolledActivityInformationSection
							wblType={localOutcomes.wblType || ''}
							unpaidHours={localOutcomes.unpaidHours || undefined}
							paidHours={localOutcomes.paidHours || undefined}
							internshipEmployer={localOutcomes.internshipEmployer || ''}
							internshipIndustry={localOutcomes.internshipIndustry || ''}
							internshipOccupation={localOutcomes.internshipOccupation || ''}
							onWblTypeChange={this.handleTextChange}
							onHoursChange={this.handleTextChange}
							onInternshipEmployerChange={this.handleTextChange}
							onInternshipIndustryChange={this.handleTextChange}
							onInternshipOccupationChange={this.handleTextChange}
							header={"Work Based Activity Information"}
              employers={this.props.employers}
						/>
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<div>
						<OtherEnrolledAcademicDetails
							earnedDegreeOrCredit={localOutcomes.earnedDegreeOrCredit}
							academicCredit={localOutcomes.academicCredit || ''}
							creditsEarned={localOutcomes.creditsEarned || ''}
							credentialType={localOutcomes.credentialType || ''}
							handleEarnedDegreeChange={this.handleEarnedAcademicDegree}
							handleTypeofCreditChange={this.handleTextChange}
							handleCreditsEarnedChange={this.handleTextChange}
							handleTypeOfCredentialChange={this.handleTextChange}
              updateDateCredentailAttained={this.props.updateDateCredentailAttained}
						/>
						<AcademicAwardDetails
							onChange={this.handleTextChange}
							value={localOutcomes.academicAwardDetail || ''}
						/>
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<div>
						<JobPlacementSection
							completionDate={localOutcomes.completionDate || undefined}
							handleJobPlacementEmployer={this.handleTextChange}
							handlePlacedJobChange={this.handlePlacedJob}
							handlePlacedJobDateChange={({ target }) => this.handleDateChange('placedJobDate', target.value)}
							label={'Permanent Job Placement Information'}
							placedJobDate={localOutcomes.placedJobDate || undefined}
							placedJobStringVal={mapToYesOrNoWithNullable(localOutcomes.placedJob)}
							startDate={localOutcomes.startDate || undefined}
							jobPlacementEmployer={localOutcomes.jobPlacementEmployer || ''}
							jobPlacementEmployerAddress1={localOutcomes.jobPlacementEmployerAddress1 || ''}
							handleJobPlacementEmployerAddress1Change={this.handleTextChange}
							jobPlacementEmployerAddress2={localOutcomes.jobPlacementEmployerAddress2 || ''}
							handleJobPlacementEmployerAddress2Change={this.handleTextChange}
							jobPlacementEmployerCity={localOutcomes.jobPlacementEmployerCity || ''}
							handleJobPlacementCityChange={this.handleTextChange}
							handleEmployerStateChange={this.handleTextChange}
							jobPlacementEmployerState={
								localOutcomes.jobPlacementEmployerState ? StateIDs[localOutcomes.jobPlacementEmployerState] : ''
							}
							jobPlacementEmployerZipcode={localOutcomes.jobPlacementEmployerZipcode || ''}
							handleJobPlacementEmployerZipcodeChange={this.handleTextChange}
							jobPlacementOccupation={localOutcomes.jobPlacementOccupation || ''}
							handleJobPlacementOccupationChange={this.handleTextChange}
							jobPlacementIndustry={localOutcomes.jobPlacementIndustry || ''}
							handleJobPlacementIndustryChange={this.handleTextChange}
							jobPlacementWage={localOutcomes.jobPlacementWage || undefined}
							handleJobPlacementWageChange={this.handleTextChange}
							jobPlacementWageFrequency={localOutcomes.jobPlacementWageFrequency || ''}
							handleWageFrequencyChange={this.handleTextChange}
							jobPlacementWeeklyHours={localOutcomes.jobPlacementWeeklyHours}
							handleJobPlacementWeeklyHoursChange={this.handleTextChange}
							benefitsProvidedStringVal={mapToYesOrNoWithNullable(localOutcomes.benefitsProvided)}
							handleBenefitsProvidedChange={this.handleBenefitsProvided}
							requiredPlacedJobDate={placedJob === "Yes"}
							requiredRole={placedJob === "Yes" || localOutcomes.placedJob === true}
							jobTitle={localOutcomes.jobTitle || ''}
							handleJobTitleChange={this.handleTextChange}
							perDiemStringVal={mapToYesOrNoWithNullable(localOutcomes.perDiem)}
							handlePerDiemChange={this.handlePerDiem}
              employers={this.props.employers}
						/>
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<div>
						<SupportedServicesSection
							isServiceProvided={localOutcomes.serviceProvided}
							startDate={localOutcomes.serviceStartDate}
							endDate={localOutcomes.serviceEndDate}
							supportiveServices={localOutcomes.services}
							updateServices={this.handleServicesChange}
							handleServiceStartDateChange={({ target }) => this.handleDateChange('serviceStartDate', target.value)}
							handleServiceEndDateChange={({ target }) => this.handleDateChange('serviceEndDate', target.value)}
							handleServiceProvidedChange={this.handleSupportiveServices}
						/>
					</div>
          {/* <Divider variant="middle" style={{ margin: '15px 0' }} />
          <div>
          <SkillGainedSection 
              outcomes={localOutcomes}
              handleDateSkillAttainedChanged={this.handleDateSkillAttainedChanged}
              handleMeasurableSkillGainChange={this.handleMeasurableSkillGainChange}
            />
          </div> */}

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<OutcomesFormActions
						onCancel={this.onCancel}
						isSubmitDisabled={R.equals(this.props.outcomesCopy, this.state.localOutcomes)}
					/>
				</form>
			</div>
		)
	}
}
const styles = (theme: Theme) =>
	createStyles({
		root: {},
	})

export default connector(withStyles(styles)(InternshipsWorkbasedLearningOtherEnrolled))
